import { useMemo } from "react";
import { ITableColumn } from "src/components/FilterSearchTable/TableComponents/TableHeader";
import { Grid, CardContent } from "@mui/material";
import { FilterSearchTable } from "src/components/FilterSearchTable/FilterSearchTable";
interface IManageProps {
  path?: string[];
  id?: string;
  tableMaxHeight: number;
  history: any;
  type: any;
}

// PAIRINGS
const HistoryTableDesc = {
  tableTitle: "",
  tableDescription: "",
  noMessage: "No history to display.",
};

const historyTableInfo: ITableColumn[] = [
  {
    id: "modBy",
    value: "modBy",
    index: 2,
    numeric: true,
    label: "Modified By",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "timeOfChange",
    value: "timeOfChange",
    index: 3,
    numeric: true,
    label: "Modified At",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "action",
    value: "action",
    index: 4,
    numeric: true,
    label: "Type",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "component",
    value: "component",
    index: 4,
    numeric: true,
    label: "History",
    type: "object",
    width: 10,
    visible: true,
    filter: false,
  },
];

const deletedFlightsTableInfo: ITableColumn = {
  id: "docId",
  value: "flight",
  index: 1,
  numeric: true,
  label: "View Full History",
  type: "icon",
  width: 10,
  visible: true,
  filter: false,
};

const deletedPairingsTableInfo: ITableColumn = {
  id: "docId",
  value: "pairing",
  index: 1,
  numeric: true,
  label: "View Full History",
  type: "icon",
  width: 10,
  visible: true,
  filter: false,
};

const deletedGroundEventsTableInfo: ITableColumn = {
  id: "docId",
  value: "groundEvents",
  index: 1,
  numeric: true,
  label: "View Full History",
  type: "icon",
  width: 10,
  visible: true,
  filter: false,
};

/**
 * Manage History
 */
export const HistoryTable = (props: IManageProps): JSX.Element => {
  const { id, path, tableMaxHeight, history, type } = props;

  const mosaicPanel = useMemo(() => `${id}-panel`, [id]);

  const tableData = useMemo(() => {
    if (type?.label === "Deleted Flights") {
      return [
        {
          id: "history",
          dataType: "history",
          label: "History",
          data: [],
          tableInfo: [...historyTableInfo, deletedFlightsTableInfo],
          tableInfoDisplay: HistoryTableDesc,
        },
      ];
    }
    if (type?.label === "Deleted Pairings") {
      return [
        {
          id: "history",
          dataType: "history",
          label: "History",
          data: [],
          tableInfo: [...historyTableInfo, deletedPairingsTableInfo],
          tableInfoDisplay: HistoryTableDesc,
        },
      ];
    }

    if (type?.label === "Deleted Ground Events") {
      return [
        {
          id: "history",
          dataType: "history",
          label: "History",
          data: [],
          tableInfo: [...historyTableInfo, deletedGroundEventsTableInfo],
          tableInfoDisplay: HistoryTableDesc,
        },
      ];
    }
    return [
      {
        id: "history",
        dataType: "history",
        label: "History",
        data: [],
        tableInfo: historyTableInfo,
        tableInfoDisplay: HistoryTableDesc,
      },
    ];
  }, [type]);

  const events = useMemo(() => {
    tableData[0].data = history;
    //why do I NOW need to spread this to have react notice the change?
    return [...tableData];
  }, [history, tableData]);

  return (
    <CardContent>
      <Grid container direction="column">
        <Grid item className="history_table_item">
          <FilterSearchTable
            id={id}
            path={path}
            className="history_display_table"
            events={events}
            parentId={mosaicPanel}
            uniqueKey={"_id"}
            // changeSelectedRows={selectBooking}
            allowMultiFilter={false}
            selectModeSingle={true}
            hideFilter={true}
            hideFocusSelected={true}
            hideSelectionCheckboxes={true}
            stickyHeader={false}
            maxTableHeight={tableMaxHeight}
          />
        </Grid>
      </Grid>
    </CardContent>
  );
};
